import React, { useState } from 'react';
import { Box, Paper, useMediaQuery, useTheme } from '@mui/material';

import { AUTH_LAYOUT_FOOTER_HEIGHT } from 'consts';
import { Onboarding } from 'dialogs/onboarding/onboarding';
import {
  AuthHeaderDesktopLayout,
  AuthMainLayout,
  AuthSidebarMenuDesktopLayout,
  AuthSidebarMenuMobileLayout,
  AuthUserDrawerHeader,
  AuthFooterLayout,
} from '.';
import { AuthHeaderMobileLayout } from './auth-header-mobile.layout';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

interface AuthLayoutProps {
  children?: React.ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const theme = useTheme();
  const down_md = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const { isAdmin } = useAppSelector(selectCurrentUserInfo);

  const PageWrapper: any = down_md ? Box : Paper;
  const pageWrapperProps = { sx: { position: 'relative' } };

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        {!down_md ? (
          <AuthHeaderDesktopLayout open={!down_md ? open : false} fullWidth={down_md} />
        ) : (
          <AuthHeaderMobileLayout />
        )}

        {!down_md ? <AuthSidebarMenuDesktopLayout open={open} setOpen={setOpen} /> : <AuthSidebarMenuMobileLayout />}

        <AuthMainLayout open={open}>
          <AuthUserDrawerHeader />

          <Box sx={{ padding: down_md ? 0 : 3 }}>
            <PageWrapper {...pageWrapperProps}>{children}</PageWrapper>
          </Box>

          {!down_md ? <Box sx={{ height: AUTH_LAYOUT_FOOTER_HEIGHT }} /> : null}
        </AuthMainLayout>

        {!down_md ? <AuthFooterLayout /> : null}
      </Box>

      {isAdmin && <Onboarding />}
    </>
  );
};
